export default function DateSelector({
  reportType,
  setReportType,
  combine,
  setCombine,
  multi,
  monthOverMonth,
  setMonthOverMonth,
  companiesVertical,
  setCompaniesVertical,
}) {
  const isTrialBalance = reportType === "TrialBalance";
  return (
    <div className="unified-box">
      <h3>Report Filters</h3>

      <div className="filter-row">
        <span>Report Type</span>
        <select value={reportType} onChange={(e) => setReportType(e.target.value)}>
          <option value="">-- Select Report --</option>
          <option value="BalanceSheet">Balance Sheet</option>
          <option value="CashFlow">Cash Flow</option>
          <option value="ProfitAndLoss">Profit & Loss</option>
          <option value="TrialBalance">Trial Balance</option>
        </select>
      </div>

      {/* 1. HIDE Month Over Month if Companies Vertical is active */}
      {!companiesVertical && !isTrialBalance && (
        <div className="filter-row">
          <span>Month Over Month</span>
          <label className="toggle">
            <input
              type="checkbox"
              checked={monthOverMonth}
              onChange={() => setMonthOverMonth(!monthOverMonth)}
            />
            <span className="slider" />
          </label>
        </div>
      )}

      {/* 2. HIDE Combine if Companies Vertical is active */}
      {multi && !companiesVertical && (
        <div className="filter-row">
          <span>Combine Data</span>
          <label className="toggle">
            <input
              type="checkbox"
              checked={combine}
              onChange={() => setCombine(!combine)}
            />
            <span className="slider" />
          </label>
        </div>
      )}

      {/* 3. HIDE Companies Vertical if Month Over Month is active */}
      {multi && !monthOverMonth && !isTrialBalance && (
        <div className="filter-row">
          <span>Companies Vertical</span>
          <label className="toggle">
            <input
              type="checkbox"
              checked={companiesVertical}
              onChange={() => setCompaniesVertical(!companiesVertical)}
            />
            <span className="slider" />
          </label>
        </div>
      )}

      <div className="generate-report-row">
        <button type="submit" className="submit-btn group-btn-primary">
          Generate Report
        </button>
      </div>
    </div>
  );
}